import { ThemedText } from "@/components/ThemedText";
import { useThemeColor } from "@/hooks/useThemeColor";
import { ActivityIndicator, StyleProp, View, ViewStyle } from "react-native";

interface LoadingIndicatorProps {
  text?: string;
  size?: "small" | "large";
  color?: string;
  style?: StyleProp<ViewStyle>;
}

export function LoadingIndicator({
  text,
  size = "large",
  color,
  style,
}: LoadingIndicatorProps) {
  const tintColor = useThemeColor({}, "tint");
  return (
    <View
      style={[
        {
          width: "100%",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
        },
        style,
      ]}
    >
      <ActivityIndicator size={size} color={color ?? tintColor} />
      {text ? <ThemedText>{text}</ThemedText> : null}
    </View>
  );
}
